import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "faq" }
const _hoisted_2 = { class: "faq__title h1 color-text-primary" }
const _hoisted_3 = { class: "categories-scroll-container desktop" }
const _hoisted_4 = { class: "categories-scroll-container mobile" }
const _hoisted_5 = { class: "categories" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 0,
  class: "faq-list"
}
const _hoisted_8 = {
  key: 0,
  class: "faq-list__wrapper"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "faq-item__question h4 color-text-primary" }
const _hoisted_11 = {
  key: 0,
  class: "faq-item__content"
}
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = {
  key: 1,
  class: "empty-state"
}

import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import { useFAQ } from "@/composables/faq/useFAQ";
import { useI18n } from "vue-i18n";
import BaseFigureForIcon from "@/components/base/BaseFigureForIcon.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'FAQViews',
  setup(__props) {

const { t } = useI18n();
const {
  activeCategory,
  categories,
  filteredFaq,
  openItems,
  slideClasses,
  toggleItem,
} = useFAQ();

const swiperOptions = {
  slidesPerView: "auto",
  spaceBetween: 6,
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_unref(t)("faq.title")), 1),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(Swiper), {
        "slides-per-view": swiperOptions.slidesPerView,
        "space-between": swiperOptions.spaceBetween
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(categories), (category) => {
            return (_openBlock(), _createBlock(_unref(SwiperSlide), {
              key: category.uuid,
              class: _normalizeClass(["category-btn caption-navbar color-text-primary", _unref(slideClasses)(category.uuid)]),
              onClick: ($event: any) => (activeCategory.value = category.uuid)
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(category.name), 1)
              ]),
              _: 2
            }, 1032, ["class", "onClick"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["slides-per-view", "space-between"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(categories), (category) => {
          return (_openBlock(), _createElementBlock("button", {
            key: category.uuid,
            class: _normalizeClass(["category-btn caption-navbar color-text-primary", _unref(slideClasses)(category.uuid)]),
            onClick: ($event: any) => (activeCategory.value = category.uuid)
          }, _toDisplayString(category.name), 11, _hoisted_6))
        }), 128))
      ])
    ]),
    (_unref(filteredFaq).length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          (_unref(filteredFaq).length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredFaq), (faq) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: faq.uuid,
                    class: "faq-item"
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["faq-item__header", { 'faq-item__header--active': _unref(openItems)[faq.uuid] }]),
                      onClick: ($event: any) => (_unref(toggleItem)(faq.uuid))
                    }, [
                      _createElementVNode("h4", _hoisted_10, _toDisplayString(faq.question), 1),
                      _createVNode(BaseFigureForIcon, {
                        icon: "more",
                        color: "secondary",
                        size: "small",
                        position: _unref(openItems)[faq.uuid] ? 'top' : 'bottom',
                        "is-button": ""
                      }, null, 8, ["position"])
                    ], 10, _hoisted_9),
                    _createVNode(_Transition, { name: "slide-fade" }, {
                      default: _withCtx(() => [
                        (_unref(openItems)[faq.uuid])
                          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                              _createElementVNode("div", {
                                class: "faq-item__answer caption-medium color-grey-light",
                                innerHTML: faq.answer
                              }, null, 8, _hoisted_12)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024)
                  ]))
                }), 128))
              ]))
            : (_unref(activeCategory))
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_unref(t)("faq.empty")), 1))
              : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})